import { HTMLProps } from "react";
import FontAwesome from "react-fontawesome";

import { SortOrder } from "common/SortOrder";

import "./Icon.scss";

type IconProps = {
  name: string;
  size?: "lg" | "2x" | "3x" | "4x" | "5x";
  spin?: boolean;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
} & Omit<HTMLProps<HTMLSpanElement>, "ref" | "size">;

export function Icon({
  name,
  size,
  spin = false,
  className = "",
  onClick,
  ...rest
}: IconProps) {
  const c = `icon ${className} ${spin && "fa-spin"} ${
    onClick && "cursor-pointer"
  }`;

  return (
    <FontAwesome
      onClick={(e) => onClick && onClick(e)}
      name={name}
      size={size}
      className={c}
      {...rest}
    />
  );
}

type SortIconProps = Omit<IconProps, "name"> & {
  sortOrder: string;
};

export function SortIcon({
  sortOrder,
  className = "",
  ...rest
}: SortIconProps) {
  const c = `sort-icon ${className}`;
  switch (sortOrder) {
    case SortOrder.Descending:
      return (
        <i className={c} {...rest}>
          <Icon className="icon-inactive" name="caret-up" />
          <Icon name="caret-down" />
        </i>
      );
    case SortOrder.Ascending:
      return (
        <i className={c} {...rest}>
          <Icon name="caret-up" />
          <Icon className="icon-inactive" name="caret-down" />
        </i>
      );
    default:
      return (
        <i className={c} {...rest}>
          <Icon className="icon-inactive" name="caret-up" />
          <Icon className="icon-inactive" name="caret-down" />
        </i>
      );
  }
}

export function getIconNameByFileExtension(fileName: string) {
  const iconTypeMap: { [index: string]: string } = {};
  iconTypeMap["ico"] = "file-image-o";
  iconTypeMap["jpg"] = "file-image-o";
  iconTypeMap["jpeg"] = "file-image-o";
  iconTypeMap["gif"] = "file-image-o";
  iconTypeMap["png"] = "file-image-o";
  iconTypeMap["bmp"] = "file-image-o";
  iconTypeMap["tiff"] = "file-image-o";
  iconTypeMap["tif"] = "file-image-o";
  iconTypeMap["txt"] = "file-text-o";
  iconTypeMap["doc"] = "file-word-o";
  iconTypeMap["docx"] = "file-word-o";
  iconTypeMap["csv"] = "file-excel-o";
  iconTypeMap["xls"] = "file-excel-o";
  iconTypeMap["xlsx"] = "file-excel-o";
  iconTypeMap["pdf"] = "file-pdf-o";
  iconTypeMap["zip"] = "file-zip-o";
  iconTypeMap["ppt"] = "file-powerpoint-o";
  iconTypeMap["pptx"] = "file-powerpoint-o";

  const fileExtensionMatch = /[^.]+$/.exec(fileName);
  if (!fileExtensionMatch) {
    return "file-o";
  }

  const extension = fileExtensionMatch[0].toLowerCase();
  return iconTypeMap[extension] || "file-o";
}
